import { BASE_COMMENT_FRAGMENT } from '../fragments/baseComment';

export const EDIT_COMMENT_MUTATION = `
  mutation EditCommentMutation($id: ID!, $content: String!) {
    me {
      editComment(id: $id, content: $content) {
        ...BaseCommentFragment
        replyTo {
          ...BaseCommentFragment
        }
      }
    }
  }

  ${BASE_COMMENT_FRAGMENT}
`;
